/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import {DownloadIcon, TicketChip} from "../../../../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import CustomFileCard from "../../../../../../../components/CustomFileCard";
import {
    DATE_TIME_FORMAT_NAME_MODEL,
    downloadActionFile,
    getDateFormat,
    sanitizeString
} from "../../../../../../../Apis/functions";

/**
 * Discrepancies found in the movement: who reviewed it, when, what was found
 * and the evidence that has to be reviewed before the materials can be
 * dispatched.
 *
 * The report is what closes the folio, so the comment the guard wrote for it is
 * read here and not as a badge above the detail. The materials of the folio are
 * read in their own section, so only the evidence of the report hangs from here.
 */
const DiscrepancyBanner = ({t, reviewedBy, reviewedAt, reason, files = null}) => {
    // The comment travels as text written by the gate, so it is read back the
    // way the service stored it and the empty one is not printed as a word
    const reportReason = sanitizeString(reason);

    return (
        <div className={"row mt-3"}>
            <div className={"col-12"}>
                <div className={"border-radius-8px border-full-error-code-150 background-error-code-50 p-3"}>
                    <div className={"d-flex align-items-center mb-3"}>
                        <div className={"mr-2 d-flex align-items-center"}>
                            <TicketChip className={"icon-color-error-code-700"}/>
                        </div>
                        {/* Both texts name the same review, so they are read on
                        the same line with no margin nor line box of their own
                        pulling one of them off the center. */}
                        <p className={"ibl-font-w-600 font-color-error-700 mr-2 mb-0"}>{reviewedBy}</p>
                        <p className={"fs-12px font-color-shades-600 mb-0"}>
                            {getDateFormat(reviewedAt, true, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                        </p>
                    </div>

                    <div className={"border-radius-8px background-general-00 p-3"}>
                        {reportReason &&
                            <p className={"fs-14px mb-3"}>{reportReason}</p>
                        }

                        {(files || []).map((file) => (
                            <div className={"mb-3"} key={file?.id}>
                                <CustomFileCard
                                    downloadAtEnd
                                    showIcon={true}
                                    Icon={file?.Icon}
                                    title={file?.userFileName || file?.name}
                                    subtitle={file?.size}
                                    fileValue={file?.filePath}
                                    showBtnDownload={false}
                                    extraActions={
                                        <div className={"d-flex gap-2"}>
                                            <ButtonAction
                                                Icon={DownloadIcon}
                                                id={`btn_db_download_report_${file?.id}`}
                                                className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                                iconClass={'mr-0'}
                                                onClick={() => downloadActionFile(file?.filePath)}
                                            />
                                        </div>
                                    }
                                    classContent="pb-3"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscrepancyBanner;
